import { onFontsReady } from "../utils/onFontsReady";
import { initFontsGate } from "../utils/initFontsGate";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
initFontsGate("Manrope", [400, 700]);

function initDeliveryAnimation(section) {
	if (!section || section.dataset.gsapDeliveryInited) return;
	section.dataset.gsapDeliveryInited = "1";

	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

	const title = section.querySelector(".wv-delivery__title");
	const tabsWrap = section.querySelector(".wv-delivery__tabs");
	const desc = section.querySelector(".wv-delivery__desc");
	const mapWrap = section.querySelector(".wv-delivery__map");

	const bits = [title, tabsWrap, desc].filter(Boolean);

	if (bits.length) gsap.set(bits, { opacity: 0, y: 14 });
	if (mapWrap) gsap.set(mapWrap, { opacity: 0 });

	const tl = gsap.timeline({
		defaults: { ease: "power2.out" },
		scrollTrigger: {
			trigger: section,
			start: "top 70%",
			once: true,
			invalidateOnRefresh: true,
		},
	});

	if (bits.length) {
		tl.to(bits, {
			opacity: 1,
			y: 0,
			duration: 0.55,
			stagger: 0.12,
			clearProps: "transform,opacity",
		});
	}

	if (mapWrap) {
		tl.to(
			mapWrap,
			{
				opacity: 1,
				duration: 0.9,
				ease: "power1.out",
				clearProps: "opacity",
			},
			"-=0.2"
		);
	}
}

function bindDeliveryTabsOnce() {
	if (document.documentElement.dataset.wvDeliveryTabsBound) return;
	document.documentElement.dataset.wvDeliveryTabsBound = "1";

	document.addEventListener("click", (e) => {
		const tab = e.target.closest("[data-wv-tab]");
		if (!tab) return;

		const root = tab.closest(".wv-delivery");
		if (!root) return;

		if (tab.classList.contains("is-active")) return;

		const src = tab.getAttribute("data-src") || "";
		if (!src) return;

		root.querySelectorAll("[data-wv-tab]").forEach((b) => b.classList.remove("is-active"));
		tab.classList.add("is-active");

		const iframe = root.querySelector("[data-wv-map]");
		if (iframe && iframe.getAttribute("src") !== src) {
			iframe.setAttribute("src", src);
		}
	});
}

onFontsReady(() => {
	bindDeliveryTabsOnce();

	document.querySelectorAll(".wv-delivery").forEach(initDeliveryAnimation);

	ScrollTrigger.refresh();
});
